import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import { connect, useDispatch } from 'react-redux';
import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { postPercentage, putPercentage, getPercentage, getPercentages } from '../../../store/actions/percentage/percentage_action';
import { REACT_ROUTES } from '../../../constants/react_routes';
import history from '../../../services/history';
import TextInput from '../../ui_components/text_input';
import { useSnackbar } from 'notistack';
import { API_PREFIX as API, API_ROUTES } from '../../../constants/api_routes';
import Autocomplete from '../../ui_components/autocomplete';
import { ARTICLE_TAB } from '../../../constants/constants';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    typography: {
		margin: theme.spacing(3, 0, 2)
    },
    form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
        '& p': {
            color: '#bf1650',
            '&::before': {
                display: 'inline',
                content: '"⚠ "'
            }
        }
	}
}));

const Percentage = ({ percentages }) => {
    const { uuid } = useParams();
    const { container, typography, form } = useStyles();
    const { control, handleSubmit, setValue, formState: { errors } } = useForm();
    const dispatch = useDispatch();
    const [article, setArticle] = useState(null);
    const [worker, setWorker] = useState(null);

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        uuid && (async () => {
            const percentage = await getPercentage(uuid);
            if (percentage?.worker) {
                const workerIri = `${API}${API_ROUTES.WORKERS}/${percentage?.worker?.uuid}`;
                setWorker(workerIri);
            }
            if (percentage?.article) {
                const articleIri = `${API}${API_ROUTES.ARTICLES}/${percentage?.article?.uuid}`;
                setArticle(articleIri);
            }
            for (const key in percentage) {
                setValue(key, percentage[key]);
            }
        })();
        !percentages.collection.length && dispatch(getPercentages());
    }, [uuid]);

    const handleArticleObject = (object) => {
        const article = object ? (object?.['@id'] || `${API}${API_ROUTES.ARTICLES}/${object?.uuid}`) : null;
        setArticle(article);
        setValue('article', article);
    }

    const handleWorkerObject = (object) => {
        const worker = object ? (object?.['@id'] || `${API}${API_ROUTES.WORKERS}/${object?.uuid}`) : null;
        setWorker(worker);
        setValue('worker', worker);
    }

    const onSubmit = (data) => {
        data.duration = data?.duration && parseInt(data.duration);
        if (uuid) {
            enqueueSnackbar(
                'Uspešno sačuvan procenat usluge/radnika', {
                variant: 'success'
            });
            return dispatch(putPercentage(uuid, data));
        }
        enqueueSnackbar(
            'Uspešno dodat procenat usluge/radnika', {
            variant: 'success'
        });
        return dispatch(postPercentage(data));
    }

    const handleClickBackToTabs = () => {
        history.push(REACT_ROUTES.ARTICLE_TABS, { selectedTab: ARTICLE_TAB });
    }

    return (
        <Container className={container}>
            <Typography align="center" variant="h4" className={typography}>Procenat usluge/radnika</Typography>
            <Grid container justify="center" spacing={3}>
                <Grid item>
                    <Button
                        color="primary"
                        size="small"
                        variant="contained"
                        onClick={handleSubmit(onSubmit)}
                        type="button"
                    >
                        Sačuvaj
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleClickBackToTabs}
                    >
                        Nazad
                    </Button>
                </Grid>
            </Grid>
            <form className={form}>
                <Grid container justify="center" spacing={3}>
                    <Grid item xs={8}>
                        <Autocomplete
                            name="article"
                            label="Usluga"
                            placeholder="Usluga"
                            control={control}
                            rules={{ required:  'Unesite uslugu' }}
                            api={API_ROUTES.ARTICLES}
                            handleObject={handleArticleObject}
                            preloadValue={article}
                        />
                        <ErrorMessage errors={errors} name="article" as="p" />
                    </Grid>
                    <Grid item xs={8}>
                        <Autocomplete
                            name="worker"
                            label="Radnik"
                            placeholder="Radnik"
                            control={control}
                            api={API_ROUTES.WORKERS}
                            handleObject={handleWorkerObject}
                            preloadValue={worker}
                        />
                        <ErrorMessage errors={errors} name="worker" as="p" />
                    </Grid>
                    <Grid item xs={8}>
                        <TextInput
                            control={control}
                            name="percentage"
                            label="Procenat %"
                        />
                    </Grid>
                </Grid>
            </form>
        </Container>
    )
}

Percentage.propTypes = {
    percentages: PropTypes.object
}

const mapStateToProps = (state) => ({
    percentages: state.percentages
});

export default connect(mapStateToProps)(Percentage);
